import { css } from 'styled-components';

export const menuItemRow = css`
  align-self: stretch;
  margin: 0 -8px;
  color: var(--color-black);
`;
